import React, { Fragment, useState } from 'react';
import { Container, Row, Col, TabContent, TabPane } from 'reactstrap';
import { IndexDoctors as ComponentDoctors } from '../../doctors/IndexDoctors';
import { TabDoctor, TabSpeciality } from '../../../constant';
import { IndexSpecialties } from '../../specialties/IndexSpecialties';
import { TabMenu } from 'primereact/tabmenu';

export const IndexDoctors = (props) => {

    const [activeTab, setActiveTab] = useState("1");

    const items = [
        {
            label: TabDoctor,
            icon: 'pi pi-user',
            command: () => setActiveTab("1")
        },
        {
            label: TabSpeciality,
            icon: 'pi pi-briefcase',
            command: () => setActiveTab("2")
        }
    ];

    return (
        <Fragment>
            <div className='container-global-zoom' >
                <Row>
                    <Col sm="12">
                        {/* TAB MENU */}
                        <TabMenu 
                            model={items} 
                            activeIndex={parseInt(activeTab) - 1} 
                            onTabChange={(e) => setActiveTab((e.index + 1).toString())} 
                            className="custom-tabmenu full-width"
                        />

                        {/* CONTENIDO DE TABLAS */}
                        <TabContent activeTab={activeTab} className="mt-3">
                            <TabPane tabId="1" className="fade show">
                                <ComponentDoctors {...props} activeTab={activeTab} />
                            </TabPane>
                            <TabPane tabId="2" className="fade show">
                                <IndexSpecialties {...props} activeTab={activeTab} />
                            </TabPane>
                        </TabContent>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}
